import { Component, HostListener, inject, OnInit, Signal, ChangeDetectionStrategy } from '@angular/core';
import { select, Store } from '@ngxs/store';
import { TranslateModule } from '@ngx-translate/core';
import { DialogService, ShButtonComponent, ShSpinnerComponent, ShTagComponent } from '@gbr-monorepo/gbr-shui';
import { WorkersCouncilGroupState } from '../../state/workers-council-group.state';
import {
    AddDelegate,
    LazyLoadWorkersCouncilGroups,
    LoadWorkersCouncilGroups,
    RemoveDelegate
} from '../../state/workers-council-group.action';
import { SelectDelegateDialogComponent } from '../../dialogs/select-delegate-dialog/select-delegate-dialog.component';
import { User } from '../../../shared/interfaces/CreateOrUpdateUserPayload';
import { WorkersCouncilGroup } from '@gbr-monorepo/interfaces';
import { scrollOverAmount } from '../../../shared/helpers/tiny-helpers';
import { BackHomeComponent } from '../../../shared/components/back-home/back-home.component';

@Component({
    selector: 'app-workers-council-group-list',
    imports: [TranslateModule, ShButtonComponent, ShTagComponent, ShSpinnerComponent, BackHomeComponent],
    templateUrl: './workers-council-group-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class WorkersCouncilGroupListComponent implements OnInit {
    private readonly dialog = inject(DialogService);
    private readonly store = inject(Store);

    protected readonly groups: Signal<WorkersCouncilGroup[]> = select(WorkersCouncilGroupState.getWorkersCouncilGroups);
    protected readonly isLoading: Signal<boolean> = select(WorkersCouncilGroupState.isLoadingWorkersCouncilGroups);
    private readonly allGroupsLoaded: Signal<boolean> = select(WorkersCouncilGroupState.allGroupsLoaded);
    protected groupsSorted = true;

    ngOnInit(): void {
        this.store.dispatch(new LoadWorkersCouncilGroups(this.groupsSorted));
    }

    @HostListener('window:scroll', ['$event'])
    onScroll(event: Event): void {
        if (!scrollOverAmount(event) || this.isLoading() || this.allGroupsLoaded()) {
            return;
        }
        this.store.dispatch(new LazyLoadWorkersCouncilGroups(this.groupsSorted));
    }

    sortBRUnit(): void {
        this.groupsSorted = !this.groupsSorted;
        this.store.dispatch(new LoadWorkersCouncilGroups(this.groupsSorted));
    }

    public openPickerDialog(id: string, delegates: User[]): void {
        this.dialog.open<User, unknown>(SelectDelegateDialogComponent, {
            width: 'min(600px, calc(100vw - 32px))',
            data: {
                delegates: delegates.map(delegate => delegate.gid),
                onAdd: (user: User) => this.store.dispatch(new AddDelegate(id, user))
            }
        });
    }

    public onRemoveDelegate(id: string, gid: string): void {
        this.store.dispatch(new RemoveDelegate(id, gid));
    }
}
